import api, { addAuthToData, addAuthToParams } from './api';

export const contactService = {
  // Create contact
  createContact: async (contactData) => {
    try {
      const dataWithAuth = addAuthToData(contactData);
      const response = await api.post('/api.php?module=contact&action=create', dataWithAuth);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Get all contacts
  getContacts: async () => {
    try {
      const response = await api.get('/api.php?module=contact&action=read');
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Get single contact
  getContact: async (id) => {
    try {
      const response = await api.get(`/api.php?module=contact&action=read&id=${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Update contact
  updateContact: async (contactData) => {
    try {
      const dataWithAuth = addAuthToData(contactData);
      const response = await api.post('/api.php?module=contact&action=update', dataWithAuth);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Delete contact
  deleteContact: async (id) => {
    try {
      const url = addAuthToParams(`/api.php?module=contact&action=delete&id=${id}`);
      const response = await api.post(url);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  }
};